module.exports = __webpack_public_path__ + "static/media/rightArrowBlue.6aec5355.svg";